import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  ContainerNota,
  ContainerNotaVcpResponse,
} from "src/app/entities/NotaCertificacao";
import { ToastType } from "src/app/entities/toast";
import { UnidadeProdutiva } from "src/app/entities/unidade-produtiva";
import { ToastService } from "src/app/services/toast.service";

@Component({
  selector: "app-exibir-vcp",
  templateUrl: "./exibir-vcp.component.html",
})
export class ExibirVcpComponent implements OnInit {
  @Input() unidadeProdutiva: UnidadeProdutiva;
  @Input() loading: boolean;
  @Input() containerNota: ContainerNotaVcpResponse;

  constructor(
    private modalService: NgbModal,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {}

  open(content) {
    if (!this.containerNota.temNotaAbr || !this.containerNota.temNotaBci) {
      return this.toastService.showToast(
        ToastType.INFO,
        "Resumo VCP",
        "Etapa VCP não iniciada"
      );
    }
    this.modalService.open(content, { centered: true, size: "xl" });
  }
}
